const my_profile = {
  viewMyClubSeacretProfile: "הצג את פרופיל ClubSeacret שלי", // translated
  viewMoreDetails: "הצג פרטים נוספים", // translated
  verifiedEmail: "אימייל מאומת", // translated
  unverifiedEmail: "אימייל לא מאומת", // translated
  createdFrom: "נוצר מ", // translated
  createdTo: "נוצר עד", // translated
  selectStatus: "בחר סטטוס...", // translated
  searchByTitle: "חפש לפי כותרת...", // translated
  pushNotifications: "התראות Push",
  pushNotificationsDescription: "קבל התראות דפדפן לעדכונים ואירועים חשובים",
  pushNotificationsNotSupported: "התראות Push אינן נתמכות בדפדפן זה",
  pushNotificationsDeniedMessage: "הרשאת ההתראה נדחתה. אנא הפעל התראות בהגדרות הדפדפן כדי לקבל התראות Push.",
  pushNotificationsEnabled: "התראות Push הופעלו בהצלחה",
  pushNotificationsDisabled: "התראות Push בוטלו בהצלחה",
  userInformationMissing: "חסרות פרטי משתמש",
  failedToUpdatePushNotifications: "נכשל בעדכון הגדרות התראות Push",
  notificationPermissionDenied: "הרשאת ההתראה נדחתה. אנא הפעל אותה בהגדרות הדפדפן.",
  notificationPermissionRequired: "נדרשת הרשאת התראה כדי להפעיל התראות Push",
  notSupported: "לא נתמך",
  permissionDenied: "הרשאה נדחתה",
  permissionNotRequested: "הרשאה לא התבקשה",
  enabled: "מופעל",
  disabled: "מושבת",
};

export default my_profile;
